import { render, staticRenderFns } from "./ticket_empty_state.vue?vue&type=template&id=41793c53"
import script from "./ticket_empty_state.vue?vue&type=script&lang=js"
export * from "./ticket_empty_state.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports